import { z } from "zod";
import { GENERATION_RATIOS } from "../../../Board/constants.ts";
import { settingsStorageFactory } from "./settingsStorageFactory.ts";

export const DEFAULT_GENERATE_GUIDANCE_SCALE = 0.5;

export const zGenerateSettings = z.object({
  prompt: z.string().default(""),
  num_generations: z.number().default(4),
  guidance_scale: z.number().default(DEFAULT_GENERATE_GUIDANCE_SCALE),
  generation_ratio: z.enum(GENERATION_RATIOS).default("r_1_1"),
  enforce_photo: z.boolean().default(false),
  photo_enabled: z.boolean().default(false),
});

export const generateSettingsStorage = settingsStorageFactory(
  "generate-settings",
  2,
  zGenerateSettings,
  () =>
    zGenerateSettings
      .omit({ prompt: true, num_generations: true, generation_ratio: true })
      .parse({}),
);
